<div class="h-xl-100">
  <div class="card-body">
    <div class="d-flex flex-stack">
      <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
        <!-- One component serves both /profile/parent and /profile/student, so
             a hard-coded "รายการผู้ปกครอง" sat above a parent's list of their
             own children. The body already switches on the same signal. -->
        <h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-1">
          {{
          isStudent()
          ? ("APP.PARENT_LIST" | translate)
          : ("APP.STUDENT_LIST" | translate)
          }}
        </h1>
        <span class="text-muted fs-7">
          {{
          isStudent()
          ? ("APP.PARENT_LIST_HINT" | translate)
          : ("APP.STUDENT_LIST_HINT" | translate)
          }}
        </span>
      </div>
      <div class="d-flex align-items-center gap-4">
        <!-- <button
      class="btn btn-sm btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800"
    >
      ยกเลิก
    </button> -->
      </div>
    </div>
    <div class="separator my-4"></div>
    <section class="col-12 pt-4" [formGroup]="form">
      <h4 class="fw-semibold mb-10">
        {{
        isStudent()
        ? ("APP.PARENT_INVITATION" | translate)
        : ("APP.FILL_INVITATION" | translate)
        }}
      </h4>
      <!-- One field, one action, sharing a row — the same shape the course
           search on the parent's course library uses. The button used to sit
           on top of the field's right border. -->
      <div class="field-row mb-15">
        <div class="field-row__field">
          <app-input data-testid="invitation-code" label="APP.PARENT_INVITATION" name="code_invitation"
            formControlName="code_invitation" [labelMode]="LabelMode.NO_LABEL" [error]="error?.code_invitation"
            [isDisabled]="isStudent()"></app-input>
        </div>
        @if (isStudent()) {
        <!-- `btn-active-light` alone paints nothing until you press it, so
               this was a bare glyph floating beside a field. Tonal, and named:
               an icon-only control with no accessible name is a control only
               sighted guessers can use. -->
        <button class="btn btn-icon btn-light-primary field-row__action " data-testid="copy-code"
          [attr.aria-label]="'APP.COPY_INVITE_CODE' | translate" [attr.title]="'APP.COPY_INVITE_CODE' | translate"
          (click)="copyClipboard()">
          @if (isCopied()) {

          <app-keenicon name="check" class="fs-1 svg svg-icon"></app-keenicon>
          }@else {
          <app-keenicon name="copy" class="fs-1 svg svg-icon"></app-keenicon>

          }
        </button>

        }@else {
        <!-- Says what it does, like the 2021 build's "เพิ่มนักเรียน" did.
               A bare "+" beside a field reads as "create a new student", which
               is not what this is and is not something a parent can do at all:
               it redeems a code the child issued from their own account. -->
        <button class="btn btn-primary d-flex align-items-center gap-2 flex-shrink-0 mh-50px" data-testid="add-student"
          [attr.aria-label]="'APP.ADD_STUDENT_BY_CODE' | translate" [attr.title]="'APP.ADD_STUDENT_BY_CODE' | translate"
          (click)="addStudent()">
          <app-keenicon name="plus-square" class="fs-3 svg svg-icon"></app-keenicon>
          {{ "APP.ADD_STUDENT" | translate }}
        </button>

        }
      </div>
    </section>

    <section class="col-12">
      <div data-kt-search-element="suggestions">
        <h4 class="fw-semibold mb-3">
          {{ isStudent() ? Role.PARENT : Role.MEMBER }}
        </h4>

        <div class="mh-375px scroll-y me-n6 pe-0">
          @if (isLoading()) {
          <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>
          <div class="separator my-1"></div>
          <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>
          <div class="separator my-1"></div>
          <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>

          } @else { @if (underParenting().length) { @for (item of
          underParenting(); track $index) {
          <ng-container [ngTemplateOutlet]="listItem" [ngTemplateOutletContext]="{ item: item }"></ng-container>

          @if (underParenting().length > 1) {

          <div class="separator my-1"></div>
          } } }@else {
          <!-- "ไม่มีรายการแสดง" describes a table, not this. Say which side of
               the link is missing, the way the 2021 build did
               ("ยังไม่มีการเชื่อมต่อกับนักเรียน" / "…กับผู้ปกครอง"). -->
          <div class="d-flex justify-content-center align-items-center h-inherit text-gray-600 fw-normal fs-6 pt-4"
            data-testid="parenting-empty">
            {{
            (isStudent() ? "APP.NO_PARENT_LINKED" : "APP.NO_STUDENT_LINKED")
            | translate
            }}
          </div>
          } }
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #skeletonItem>
  <a class="d-flex align-items-center p-3 py-4 rounded bg-state-light bg-state-opacity-50 mb-1 cursor-unset">
    <div class="skeleton symbol symbol-35px w-35px h-35px symbol-circle me-5"></div>

    <div class="d-flex flex-column gap-2">
      <div class="d-flex flex-row align-items-center fw-bold w-auto">
        <div class="skeleton h-15px w-125px fs-6 me-3"></div>
        <div class="skeleton fw-semibold h-10px w-60px px-2 py-2"></div>
      </div>
      <div class="skeleton h-10px w-80px"></div>
    </div>
  </a>
</ng-template>

<ng-template #listItem let-item="item">
  <a
    class="d-flex justify-content-between align-items-center p-3 rounded bg-state-light bg-state-opacity-50 mb-1 cursor-unset">
    <section class="d-flex align-items-center">
      <div class="symbol symbol-35px symbol-circle me-4">
        @if (item.parent?.image_url || item.student?.image_url) {
        <img [attr.alt]="item.parent?.full_name || item.student?.full_name || '-'" class="object-fit-cover"
          [src]="fileUrl + (item.parent?.image_url || item.student?.image_url)" />
        } @else {
        <span class="symbol-label bg-light-primary text-primary">
          <app-keenicon name="user" class="fs-2 text-primary"></app-keenicon>
        </span>
        }
      </div>

      <div class="d-flex flex-column">
        <div class="fw-semibold">
          <span class="fs-5 text-gray-800 me-3">{{
            item.parent?.full_name || item.student?.full_name
            }}</span>
          @if (isStudent()) {
          <span class="badge badge-light px-2 py-2">{{ "APP.CONTACT" | translate }}: {{ item.parent?.phone }}</span>
          }
        </div>

        <span class="text-muted fs-7">
          {{
          !isStudent()
          ? ("APP.CARETAKER" | translate)
          : ("APP.TAKING_CARE" | translate)
          }}
          {{ item.parentings || item.under_parentings }}
          {{ "APP.PERSON" | translate }}
        </span>
      </div>
    </section>
    @if (!isStudent() && !isLoading()) {
    <button data-testid="unlink-student" (mouseenter)="onHover()" (mouseleave)="onLeave()"
      (click)="unlinkStudent(item.id)" class="btn btn-sm btn-icom btn-light-danger w-auto p-2">
      <div class="d-flex align-items-center">
        <app-keenicon [name]="linkIcon()" class="fs-3 svg svg-icon"></app-keenicon>
      </div>
    </button>

    }
  </a>
</ng-template>